import {Pipe, PipeTransform} from '@angular/core';
import {User} from '../classes/user.class';

@Pipe({
    name: 'userName'
})
export class UserNamePipe implements PipeTransform {
    transform(userId: number, users: User[]): string {
        const user = users?.find(c => c.id === userId);
        return user?.name ?? '';
    }
}
